import { library } from '@fortawesome/fontawesome-svg-core';
import { faAddressBook, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight,
  faArrowAltDown, faArrowAltLeft, faArrowAltUp, faArrowCircleRight, faAt,
  faBars, faBold, faCalendarAlt, faCheck, faCheckSquare, faChevronDown, faChevronLeft,
  faChevronRight, faChevronUp, faCode, faCog, faCopy,
  faEdit, faEnvelope, faEnvelopeOpenText, faEraser, faExclamationTriangle, faEye, faEyeSlash,
  faFile, faFileAlt, faFileArchive, faFileAudio, faFileCode, faFileImage, faFileMinus,
  faFilePdf,
  faFileVideo, faFileWord, faFileExcel, faFilePowerpoint,
  faFolders, faFolderTree, faFont,
  faH1, faH2, faH3, faHeading, faHighlighter, faHorizontalRule,
  faIconsAlt, faImage, faIndent, faItalic, faLink,
  faList, faListOl, faLock, faMagic, faOmega, faOutdent,
  faPaperclip as faPaperclipBold, faPaperPlane, faParagraph, faPencil, faPlus, faQuestionCircle, faQuoteRight,
  faRedo, faRemoveFormat, faReply, faReplyAll,
  faSave, faSearch, faShare, faSignOutAlt, faSlash, faSpinnerThird,
  faSquare as faSquareSolid, faStar, faStrikethrough, faSyncAlt,
  faTextSize, faTimes, faTint, faToggleOff, faToggleOn, faTrashAlt,
  faUnderline, faUndo, faUnlink, faUser, faUsers }
  from '@fortawesome/pro-solid-svg-icons';
import { faPaperclip, faStar as faStarEmpty, faTimes as faTimesLight } from '@fortawesome/pro-light-svg-icons';
import { faCheckSquare as faCheckSquareReg, faGlobe as faGlobeReg, faImage as faImageReg, faListAlt as faListAltReg,
  faSquare, faSmile, faWindowClose } from '@fortawesome/pro-regular-svg-icons';

library.add(faAddressBook, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight,
  faArrowAltDown, faArrowAltLeft, faArrowAltUp, faArrowCircleRight, faAt,
  faBars, faBold, faCalendarAlt, faCheck, faCheckSquare, faChevronDown, faChevronLeft,
  faChevronRight, faChevronUp, faCode, faCog, faCopy,
  faEdit, faEnvelope, faEnvelopeOpenText, faEraser, faExclamationTriangle, faEye, faEyeSlash,
  faFile, faFileAlt, faFileArchive, faFileAudio, faFileCode, faFileImage, faFileMinus,
  faFilePdf,
  faFileVideo, faFileWord, faFileExcel, faFilePowerpoint,
  faFolders, faFolderTree, faFont,
  faH1, faH2, faH3, faHeading, faHighlighter, faHorizontalRule,
  faIconsAlt, faImage, faIndent, faItalic, faLink,
  faList, faListOl, faLock, faMagic, faOmega, faOutdent,
  faPaperclipBold, faPaperPlane, faParagraph, faPencil, faPlus, faQuestionCircle, faQuoteRight,
  faRedo, faRemoveFormat, faReply, faReplyAll,
  faSave, faSearch, faShare, faSignOutAlt, faSlash, faSpinnerThird,
  faSquareSolid, faStar, faStrikethrough, faSyncAlt,
  faTextSize, faTimes, faTint, faToggleOff, faToggleOn, faTrashAlt,
  faUnderline, faUndo, faUnlink, faUser, faUsers);

library.add(faPaperclip, faStarEmpty, faTimesLight);
library.add(faCheckSquareReg, faGlobeReg, faImageReg, faListAltReg, faSquare, faSmile, faWindowClose);
